import { RepositoryFactory } from "@/js/repository/RepositoryFactory";
const carOperatorRepository = RepositoryFactory.get("carOperator");

const state = () => ({
  data: {}
});
const getters = {};
const mutations = {
  setCarOperator(state, payload) {
    state.data = payload;
  },
  setRegisteredCarOperator(state, payload) {
    state.registeredData = payload;
  },
  setSuccessObject(state, payload) {
    state.successObject = payload;
  }
};
const actions = {
  async loadCarOperator(context) {
    const carOperators = await carOperatorRepository.list();
    if (carOperators.status < 300) {
      context.commit("setCarOperator", carOperators.data);
    }
  },
  async entryCarOperator(context, payload) {
    const requestParameter = {
      company_name: payload.company.company_name,
      sales_office_name: payload.company.sales_office_name,
      carop_cls: payload.company.carop_cls,
      tel_no: payload.company.tel_no,
      mail_address: payload.company.mail_address
    };
    const carOperators = await carOperatorRepository.entry(
      payload.screenId,
      requestParameter
    );
    if (carOperators.status < 300) {
      context.commit("setRegisteredCarOperator", carOperators.data);
      context.commit("setSuccessObject", carOperators);
    }
  },
  async updateCarOperator(context, payload) {
    const requestParameter = {
      carop_id: payload.company.carop_id,
      company_name: payload.company.company_name,
      sales_office_name: payload.company.sales_office_name,
      carop_cls: payload.company.carop_cls,
      tel_no: payload.company.tel_no,
      mail_address: payload.company.mail_address,
      modified_hash: payload.company.modified_hash
    };
    const carOperators = await carOperatorRepository.update(
      payload.screenId,
      requestParameter
    );
    if (carOperators.status < 300) {
      context.commit("setRegisteredCarOperator", carOperators.data);
      context.commit("setSuccessObject", carOperators);
    }
  },
  async deleteCarOperator(context, payload) {
    const requestParameter = {
      carop_id: payload.company.carop_id,
      modified_hash: payload.company.modified_hash
    };
    const carOperators = await carOperatorRepository.delete(
      payload.screenId,
      requestParameter
    );
    if (carOperators.status < 300) {
      context.commit("setSuccessObject", carOperators);
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
